// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PlaceOrderData from "../entity/PlaceOrderData.bs.js";

function reducer(state, action) {
  if (typeof action === "number") {
    if (action === /* ClearSnackbar */0) {
      return {
              currentStep: state.currentStep,
              pickupAddress: state.pickupAddress,
              dropAddress: state.dropAddress,
              selectedVehicle: state.selectedVehicle,
              geo_region: state.geo_region,
              goods_type: state.goods_type,
              customerInfo: state.customerInfo,
              isRebook: state.isRebook,
              snackbarMessage: undefined,
              wayPointOne: state.wayPointOne,
              wayPointTwo: state.wayPointTwo,
              wayPointThree: state.wayPointThree,
              restricted_vehicles: state.restricted_vehicles,
              vehicles: state.vehicles,
              parentOrderId: state.parentOrderId,
              selectedGoodsType: state.selectedGoodsType
            };
    } else {
      return {
              currentStep: state.currentStep,
              pickupAddress: state.pickupAddress,
              dropAddress: state.dropAddress,
              selectedVehicle: state.selectedVehicle,
              geo_region: state.geo_region,
              goods_type: state.goods_type,
              customerInfo: state.customerInfo,
              isRebook: state.isRebook,
              snackbarMessage: state.snackbarMessage,
              wayPointOne: state.wayPointOne,
              wayPointTwo: state.wayPointTwo,
              wayPointThree: state.wayPointThree,
              restricted_vehicles: [],
              vehicles: state.vehicles,
              parentOrderId: state.parentOrderId,
              selectedGoodsType: state.selectedGoodsType
            };
    }
  }
  switch (action.TAG | 0) {
    case /* ChangeCurrentStep */0 :
        return {
                currentStep: action._0,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: state.geo_region,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* SetLatLng */1 :
        var latLng = action._1;
        switch (action._0) {
          case /* PickUp */0 :
              var init = state.pickupAddress;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: {
                        latLng: latLng,
                        address1: init.address1,
                        address2: init.address2,
                        senderName: init.senderName,
                        senderNumber: init.senderNumber
                      },
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* Drop */1 :
              var init$1 = state.dropAddress;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: {
                        latLng: latLng,
                        address1: init$1.address1,
                        address2: init$1.address2,
                        senderName: init$1.senderName,
                        senderNumber: init$1.senderNumber
                      },
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointOne */2 :
              var init$2 = state.wayPointOne;
              var init$3 = state.wayPointOne.address;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: {
                        address: {
                          latLng: latLng,
                          address1: init$3.address1,
                          address2: init$3.address2,
                          senderName: init$3.senderName,
                          senderNumber: init$3.senderNumber
                        },
                        id: init$2.id,
                        showForm: init$2.showForm
                      },
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointTwo */3 :
              var init$4 = state.wayPointTwo;
              var init$5 = state.wayPointTwo.address;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: {
                        address: {
                          latLng: latLng,
                          address1: init$5.address1,
                          address2: init$5.address2,
                          senderName: init$5.senderName,
                          senderNumber: init$5.senderNumber
                        },
                        id: init$4.id,
                        showForm: init$4.showForm
                      },
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointThree */4 :
              var init$6 = state.wayPointThree;
              var init$7 = state.wayPointOne.address;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: {
                        address: {
                          latLng: latLng,
                          address1: init$7.address1,
                          address2: init$7.address2,
                          senderName: init$7.senderName,
                          senderNumber: init$7.senderNumber
                        },
                        id: init$6.id,
                        showForm: init$6.showForm
                      },
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          
        }
    case /* SetSelectedVehicle */2 :
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: action._0,
                geo_region: state.geo_region,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* SetGeoRegion */3 :
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: action._0,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* SetGoodsType */4 :
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: state.geo_region,
                goods_type: action._0,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* AddNewWayPonit */5 :
        switch (action._0) {
          case /* None */0 :
              return state;
          case /* First */1 :
              var init$8 = state.wayPointOne;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: {
                        address: init$8.address,
                        id: init$8.id,
                        showForm: true
                      },
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* Second */2 :
              var init$9 = state.wayPointTwo;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: {
                        address: init$9.address,
                        id: init$9.id,
                        showForm: true
                      },
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* Third */3 :
              var init$10 = state.wayPointThree;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: {
                        address: init$10.address,
                        id: init$10.id,
                        showForm: true
                      },
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          
        }
    case /* UpdateWaypoint */6 :
        return state;
    case /* RemoveWayPoint */7 :
        switch (action._0) {
          case /* PickUp */0 :
          case /* Drop */1 :
              return state;
          case /* WayPointOne */2 :
              var init$11 = state.wayPointOne;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: {
                        address: PlaceOrderData.initialAddress,
                        id: init$11.id,
                        showForm: false
                      },
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointTwo */3 :
              var init$12 = state.wayPointTwo;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: {
                        address: PlaceOrderData.initialAddress,
                        id: init$12.id,
                        showForm: false
                      },
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointThree */4 :
              var init$13 = state.wayPointThree;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: {
                        address: PlaceOrderData.initialAddress,
                        id: init$13.id,
                        showForm: false
                      },
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          
        }
    case /* OpenSnackbar */8 :
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: state.geo_region,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: action.snackbar_message,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* SetAddress */9 :
        var address = action._1;
        switch (action._0) {
          case /* PickUp */0 :
              return {
                      currentStep: state.currentStep,
                      pickupAddress: address,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* Drop */1 :
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: address,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointOne */2 :
              var init$14 = state.wayPointOne;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: {
                        address: address,
                        id: init$14.id,
                        showForm: init$14.showForm
                      },
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointTwo */3 :
              var init$15 = state.wayPointTwo;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: {
                        address: address,
                        id: init$15.id,
                        showForm: init$15.showForm
                      },
                      wayPointThree: state.wayPointThree,
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          case /* WayPointThree */4 :
              var init$16 = state.wayPointThree;
              return {
                      currentStep: state.currentStep,
                      pickupAddress: state.pickupAddress,
                      dropAddress: state.dropAddress,
                      selectedVehicle: state.selectedVehicle,
                      geo_region: state.geo_region,
                      goods_type: state.goods_type,
                      customerInfo: state.customerInfo,
                      isRebook: state.isRebook,
                      snackbarMessage: state.snackbarMessage,
                      wayPointOne: state.wayPointOne,
                      wayPointTwo: state.wayPointTwo,
                      wayPointThree: {
                        address: address,
                        id: init$16.id,
                        showForm: init$16.showForm
                      },
                      restricted_vehicles: state.restricted_vehicles,
                      vehicles: state.vehicles,
                      parentOrderId: state.parentOrderId,
                      selectedGoodsType: state.selectedGoodsType
                    };
          
        }
    case /* SetRestrictedVehicleIds */10 :
        var array = state.restricted_vehicles;
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: state.geo_region,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: array.concat(action._0),
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* SetVehicles */11 :
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: state.geo_region,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: state.isRebook,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: action._0,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    case /* SetIsRebook */12 :
        return {
                currentStep: state.currentStep,
                pickupAddress: state.pickupAddress,
                dropAddress: state.dropAddress,
                selectedVehicle: state.selectedVehicle,
                geo_region: state.geo_region,
                goods_type: state.goods_type,
                customerInfo: state.customerInfo,
                isRebook: action._0,
                snackbarMessage: state.snackbarMessage,
                wayPointOne: state.wayPointOne,
                wayPointTwo: state.wayPointTwo,
                wayPointThree: state.wayPointThree,
                restricted_vehicles: state.restricted_vehicles,
                vehicles: state.vehicles,
                parentOrderId: state.parentOrderId,
                selectedGoodsType: state.selectedGoodsType
              };
    
  }
}

var initialState = PlaceOrderData.initialState;

export {
  initialState ,
  reducer ,
  
}
/* PlaceOrderData Not a pure module */
